import React from 'react';
import { Field } from 'formik';
import { Fields, Columns } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS } from '../Form/Form.types';
import { Props } from './CurrentPension.types';

const CurrentPension: React.FC<Props> = ({ prefix }) => {
  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.STATE_PENSION}
        name={`${prefix}.${FIELDS.STATE_PENSION}`}
        variant={VARIANTS_TYPES.CURRENCY}
      />

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.DEFINED_BENEFIT}
          name={`${prefix}.${FIELDS.DEFINED_BENEFIT}`}
          variant={VARIANTS_TYPES.CURRENCY}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.PER_PASSED_ON_DEATH_NEXT_TO_DEF_BENEFIT}
          name={`${prefix}.${FIELDS.PER_PASSED_ON_DEATH_NEXT_TO_DEF_BENEFIT}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
        />
      </Columns>

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.DEFINED_CONTRIBUTION}
          name={`${prefix}.${FIELDS.DEFINED_CONTRIBUTION}`}
          variant={VARIANTS_TYPES.CURRENCY}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.PER_PASSED_ON_DEATH_NEXT_TO_DEF_CONTRIBUTION}
          name={`${prefix}.${FIELDS.PER_PASSED_ON_DEATH_NEXT_TO_DEF_CONTRIBUTION}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
        />
      </Columns>

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.ANNUITY}
          name={`${prefix}.${FIELDS.ANNUITY}`}
          variant={VARIANTS_TYPES.CURRENCY}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.PER_PASSED_ON_DEATH_NEXT_TO_ANNUITY}
          name={`${prefix}.${FIELDS.PER_PASSED_ON_DEATH_NEXT_TO_ANNUITY}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
        />
      </Columns>
    </>
  );
};

export default CurrentPension;
